<script lang="ts" setup>
import {
  Community,
  CommunityStatus,
  UserCommunity,
} from '@/models/community.model';
import { Mutations, ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import CommunityForm from '../municipalities/CommunityForm.vue';
import { NEW_ID } from '@/util/constants';

const store = useStore<ShiftCMSState & { us: UsersState }>();

const communities = computed<Community[]>(() => store.state.us.communities);

const update = () => {
  store.dispatch(UsersActions.GetCommunitiesList);
};

const addCommunity = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(CommunityForm),
    data: {
      id: NEW_ID,
      name: '',
      groupUrl: '',
      status: CommunityStatus.Pending,
      municipality: null,
      ambassador: null,
      members: [],
    },
  });
};

function editCommunity(evt: Event, { item }: { item: Community }) {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(CommunityForm),
    data: item,
  });
}

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const headers = [
  { title: 'ID', key: 'id', width: '5%' },
  { title: 'Municipality', key: 'municipality.name', width: '15%' },
  { title: 'Name', key: 'name', width: '15%' },
  { title: 'Ambassador', key: 'ambassador', width: '15%' },
  { title: 'Members', key: 'members', width: '15%' },
];
</script>
<template>
  <v-container>
    <h2>Communities</h2>

    <v-data-table
      density="compact"
      @click:row="editCommunity"
      :headers="headers"
      :items="communities"
      hover
    >
      <template v-slot:item.ambassador="{ value }">
        {{ value ? `${value.firstName} ${value.lastName}` : '-' }}
      </template>
      <template v-slot:item.members="{ value, item }">
        <v-tooltip text="These users are confirmed members"
          ><template v-slot:activator="{ props }">
            <v-chip
              class="mr-2"
              color="success"
              density="compact"
              v-bind="props"
              >{{
                value.filter((v: UserCommunity) => !v.isTemporary).length
              }}</v-chip
            >
          </template></v-tooltip
        >
        <v-tooltip
          v-if="value.filter((v: UserCommunity) => v.isTemporary).length"
          text="These users have not confirmed membership"
          ><template v-slot:activator="{ props }">
            <v-chip
              color="secondary"
              class="mr-2"
              density="compact"
              v-bind="props"
              >{{
                value.filter((v: UserCommunity) => v.isTemporary).length
              }}</v-chip
            >
          </template></v-tooltip
        >
        <v-tooltip
          v-if="item.userCount !== 0"
          text="This is the membership count shown in the app"
          ><template v-slot:activator="{ props }">
            <v-chip
              class="mr-2"
              color="info"
              density="compact"
              v-bind="props"
              >{{ item.userCount }}</v-chip
            >
          </template></v-tooltip
        >
      </template>
    </v-data-table>

    <v-btn @click="addCommunity" color="success">Add Community</v-btn>
  </v-container>
</template>
<style scoped>
.date {
  font-size: 70%;
}
</style>
